import { Icon } from "semantic-ui-react";

import { DMS_CAPABILITY_SUPPORTED_STATUSES } from "models";

type SupportIconProps = {
  isSupported?: DMS_CAPABILITY_SUPPORTED_STATUSES;
};

const NOT_SUPPORTED_ICON = "circle xmark dms-capability-not-supported";

const SupportIconMap = new Map<DMS_CAPABILITY_SUPPORTED_STATUSES, string>([
  [DMS_CAPABILITY_SUPPORTED_STATUSES.Supported, "circle check dms-capability-supported"],
  [DMS_CAPABILITY_SUPPORTED_STATUSES.Unsupported, NOT_SUPPORTED_ICON],
  [DMS_CAPABILITY_SUPPORTED_STATUSES.Unknown, "circle question dms-capability-partially-supported"]
]);

export const SupportIcon = ({ isSupported }: SupportIconProps) => {
  const supportIcon = isSupported === undefined ? undefined : SupportIconMap.get(isSupported);

  return <Icon className={supportIcon ?? NOT_SUPPORTED_ICON} />;
};
